define('vspot-angular/resources/admin-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        // NOTE: Not a practical restriction when id is a valid paramter that some controllers need to receive.
        // return $resource('/admin/:controller:id',
        return $resource('/admin/:controller',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                getEmailFooter: {
                    method: 'POST',
                    params: {
                        controller: 'get_emailfooter'
                    }
                },
                
                addEmailFooter: {
                    method: 'POST',
                    params: {
                        controller: 'add_emailfooter'
                    }
                },
                
                // List all the building blocks
                listBuildingBlocks: {
                    method: 'GET',
                    params: {
                        controller: 'building_block_list'
                    },
                    cache: false
                },
                
                // Get 1 building block
                getBuildingBlock: {
                    method: 'GET',
                    params: {
                        controller: 'building_block_get'
                    }
                },
                
                saveBuildingBlock: {
                    method: 'POST',
                    params: {
                        controller: 'building_block_save'
                    }
                },
                
                deleteBuildingBlock: {
                    method: 'POST',
                    params: {
                        controller: 'building_block_delete'
                    }
                },

                // Get the list of widget types
                widgetTypes : {
                    method: 'GET',
                    params: {
                        controller: 'widget_types'
                    }
                },

                // List all the widgets
                listWidgets: {
                    method: 'GET',
                    params: {
                        controller: 'widget_list'
                    },
                    cache: false
                },
                
                saveWidget: {
                    method: 'POST',
                    params: {
                        controller: 'widget_save'
                    }
                },
                
                deleteWidget: {
                    method: 'POST',
                    params: {
                        controller: 'widget_delete'
                    }
                },
                
                widgetsByBuildingBlock: {
                    method: 'POST',
                    params: {
                        controller: 'widget_groups_with_widgets_with_certain_titles'
                    }
                },
                
                sitesList: {
                    method: 'GET',
                    params: {
                        controller: 'sites_list'
                    },
                    cache: false
                },
                
                bannerImageList: {
                    method: 'GET',
                    params: {
                        controller: 'banner_image_list'
                    },
                    cache: false
                },

                articleHeadersList: {
                    method: 'GET',
                    params: {
                        controller: 'article_headers_list'
                    },
                    cache: false
                },
                
                resourceTypes: {
                    method: 'GET',
                    params: {
                        controller: 'resource_types'
                    },
                    cache: false
                },
                
                resourceStatus: {
                    method: 'GET',
                    params: {
                        controller: 'resource_status'
                    },
                    cache: false
                },
                
                listResources: {
                    method: 'GET',
                    params: {
                        controller: 'resource_list'
                    },
                    cache: false
                },
                
                // Get 1 resource
                getResource: {
                    method: 'GET',
                    params: {
                        controller: 'resource_get'
                    },
                    cache: false
                },
                
                saveResourceSimple: {
                    method: 'POST',
                    params: {
                        controller: 'resource_simple_save'
                    }
                },
                
                saveResource: {
                    method: 'POST',
                    params: {
                        controller: 'resource_save'
                    }
                },
                
                deleteResource: {
                    method: 'POST',
                    params: {
                        controller: 'resource_delete'
                    }
                },

                wepaySubscriptions: {
                    method: 'POST',
                    params: {
                        controller: 'wepay_subscription'
                    }
                },
                
                wepaySubscriptionCharges: {
                    method: 'POST',
                    params: {
                        controller: 'wepay_subscription_charge'
                    }
                },
                
                wepaySubscriptionCancel: {
                    method: 'POST',
                    params: {
                        controller: 'wepay_subscription_cancel'
                    }
                },
                
                wepaySubscriptionChargeRefund: {
                    method: 'POST',
                    params: {
                        controller: 'wepay_subscription_charge_refund'
                    }
                },
                
                showOrganizations: {
                    method: 'POST',
                    params: {
                        controller: 'show_organizations'
                    }
                },
                
                addUserToOrganization: {
                    method: 'POST',
                    params: {
                        controller: 'add_user_to_organization'
                    }
                },
                
                listOrganizationsForUser: {
                    method: 'POST',
                    params: {
                        controller: 'list_organizations_for_user'
                    }
                },
                
                listUsersForOrganization: {
                    method: 'POST',
                    params: {
                        controller: 'list_users_for_organization'
                    }
                },
                
                listActivitiesForOrganization: {
                    method: 'POST',
                    params: {
                        controller: 'list_activities_for_organization'
                    }
                },
                
                deleteUserFromOrganization: {
                    method: 'POST',
                    params: {
                        controller: 'delete_user_from_organization'
                    }
                },
                
                makeOrganizationAdFree: {
                    method: 'POST',
                    params: {
                        controller: 'make_organization_ad_free'
                    }
                },
                
                makeOrganizationPay: {
                    method: 'POST',
                    params: {
                        controller: 'make_organization_pay'
                    }
                },
                
                checkShortUrl: {
                    method: 'POST',
                    params: {
                        controller: 'check_vanity_url'
                    }
                },
                
                makeShortUrl: {
                    method: 'POST',
                    params: {
                        controller: 'vanity_url'
                    }
                },
                
                getUserIdByEmail: {
                    method: 'POST',
                    params: {
                        controller: 'get_user_id_by_email'
                    }
                },

                inspectUserById: {
                    method: 'POST',
                    params: {
                        controller: 'inspect_user_by_id'
                    }
                },
                downloadUserById: {
                    method: 'POST',
                    params: {
                        controller: 'export_user_by_id'
                    }
                },

                freeCampusPlan: {
                    method: 'POST',
                    params: {
                        controller: 'free_campus_plan'
                    }
                },
                
                invitationsByUserId: {
                    method: 'POST',
                    params: {
                        controller: 'invitations_by_user_id'
                    }
                },
                
                rebuildNav: {
                    method: 'POST',
                    params: {
                        controller: 'rebuild_nav_tree'
                    }
                },

                stripeListAllPlans: {
                    method: 'GET',
                    params: {
                        controller: 'admin_list_stripe_plans'
                    },
                    cache: false
                },
                
                stripeListUser: {
                    method: 'POST',
                    params: {
                        controller: 'admin_find_stripe_plan_for_user'
                    }
                },
                
                stripeCancelUser: {
                    method: 'POST',
                    params: {
                        controller: 'admin_cancel_stripe_customer'
                    }
                },
                
                stripeListChargesForUser: {
                    method: 'POST',
                    params: {
                        controller: 'admin_list_stripe_charges_for_customer'
                    }
                }
            }
        );
    }];
});
